/** Fixed canvas dimensions for scene layout. Used so text proportions and wrapping match between main scene and sidebar preview. */
export const SCENE_BASE_WIDTH = 1920;
export const SCENE_BASE_HEIGHT = 1080;

/** Scene-container inner padding at design resolution (typography.css
 *  `--scene-padding`). The content "safe area" that templates lay out inside. */
export const SCENE_PADDING = 100;

/**
 * Layout values at 1920×1080 design resolution (unitless).
 * Applied via calc(VALUE * var(--scene-font-scale, 1) * 1px) so they scale with the scene.
 */
export const SCENE_LAYOUT = {
    /** Inner padding for templates D, E */
    padding: 72,
    /** Gap between text and media in template D */
    gap: 72,
    /** Vertical margin on media container in template D */
    mediaMarginY: 72,
    /** Border-radius on media items */
    mediaRadius: 20,
    /** Top offset on text block for templates D, E, F — leaves headroom for future top element/logo */
    textTopOffset: 0, // 40
} as const;
